import { app } from "./main-app"
import i18n from "@/libs/i18n"

app.use(i18n)
